module.exports = __webpack_public_path__ + "img/dream.b5a4157a.svg";